import { createContext } from 'react'

let count = 0

const unique = (prefix = '') => prefix + ++count

export const context = createContext(unique)
